// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".expression_ZHaShlUL{display:flex;margin-bottom:9px}.fact_vhW4HkcN{flex:1 0 0}.operator_5\\+kuKWxE{flex:1 0 0;margin-left:8px}.value_tEkr3XZq{flex:3 0 0;margin-left:8px}.remove_0AllMUh5{flex:0 0 0;margin-left:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"expression": "expression_ZHaShlUL",
	"fact": "fact_vhW4HkcN",
	"operator": "operator_5+kuKWxE",
	"value": "value_tEkr3XZq",
	"remove": "remove_0AllMUh5"
};
export default ___CSS_LOADER_EXPORT___;
